import { render, staticRenderFns } from "./Ocorrencia.vue?vue&type=template&id=76b71ccf&scoped=true"
import script from "./Ocorrencia.vue?vue&type=script&lang=js"
export * from "./Ocorrencia.vue?vue&type=script&lang=js"
import style0 from "./Ocorrencia.vue?vue&type=style&index=0&id=76b71ccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b71ccf",
  null
  
)

export default component.exports